import { render, staticRenderFns } from "./TicketBookEditor.vue?vue&type=template&id=1dbca675&"
import script from "./TicketBookEditor.vue?vue&type=script&lang=js&"
export * from "./TicketBookEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports